import styled from "styled-components"
import { Flex, Box } from "rebass/styled-components"

export const UList = styled.ul`
  margin-left: -20px;
`

export const ULItem = styled.li`
  list-style: none;
`

export const Row = styled(Flex)`
  flex-direction: row;
`

export const Column = styled(Flex)`
  flex-direction: column;
`

export const Section = styled(Box)``
